import { insertTable, getNode, setActiveTool } from "../../../commands/custom-commands";
import { deleteTable } from "prosemirror-tables";
import { customSchema } from "../../../schemas/custom-schema";

export default class TableTool {
  constructor(editorView, containerElement) {
    this.view = editorView;
    this.buildContainer();
    this.buildDialog();
    this.bindActions();
    containerElement.appendChild(this.containerElement);
    this.update(editorView);
  }

  buildContainer() {
    this.containerElement = document.createElement("div");
    this.containerElement.className = "editor-button-container";
    this.buttonElement = document.createElement("button");
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.className = "editor-toolbar-button";
    this.buttonElement.style.anchorName = "--table-anchor";
    this.buttonElement.dataset.action = "table";
    this.buttonElement.setAttribute("aria-expanded", "false");
    this.buttonElement.title =" Generar tabla";
    const iconSpan = document.createElement("span"),
      labelSpan = document.createElement("span");
    iconSpan.textContent = "Tabla";
    labelSpan.className = "oculto-visual";
    labelSpan.textContent = "Tabla";
    this.buttonElement.appendChild(iconSpan);
    this.buttonElement.appendChild(labelSpan);
    this.containerElement.appendChild(this.buttonElement);
  }

  buildDialog() {
    const buttonsContainer = document.createElement("div");

    this.dialogElement = document.createElement("div");
    this.dialogElement.className = "editor-dialog";
    this.dialogElement.style.positionAnchor = "--table-anchor";
    this.rowsInput = document.createElement("input");
    this.rowsInput.setAttribute("placeholder", "Filas");
    this.rowsInput.className = "editor-input";
    //this.rowsInput.required = true;
    this.rowsInput.type = "text";

    this.colsInput = document.createElement("input");
    this.colsInput.setAttribute("placeholder", "Columnas");
    this.colsInput.className = "editor-input";
    //this.colsInput.required = true;
    this.colsInput.type = "text";

    this.submitButton = document.createElement("button");
    this.submitButton.type = "button";
    this.submitButton.className = "editor-button";
    this.submitButton.textContent = "Agregar";

    this.removeButton = document.createElement("button");
    this.removeButton.type = "button";
    this.removeButton.className = "editor-button";
    this.removeButton.textContent = "Remover";

    buttonsContainer.className = "editor-buttons-container";
    buttonsContainer.appendChild(this.submitButton);
    buttonsContainer.appendChild(this.removeButton);

    this.dialogElement.appendChild(this.rowsInput);
    this.dialogElement.appendChild(this.colsInput);
    this.dialogElement.appendChild(buttonsContainer);

    this.containerElement.appendChild(this.dialogElement);
  }

  bindActions() {
    this.buttonAction = this.buttonClickCallback();
    this.removeAction = this.removeButtonClickCallback();
    this.submitAction = this.submitButtonClickCallback();
    this.buttonElement.addEventListener("click", this.buttonAction);
    this.submitButton.addEventListener("click", this.submitAction);
    this.removeButton.addEventListener("click", this.removeAction);
  }

  update(view) {
    const node = getNode(view.state, customSchema.nodes.table),
      isEnabled = insertTable(1, 1)(view.state, null);
    if(!!node) { 
      this.rowsInput.value = node.content.content.length;
      this.colsInput.value = node.content.content[0].content.content.length;
      this.buttonElement.setAttribute("aria-pressed", "true");
      this.removeButton.removeAttribute("disabled");
      this.submitButton.disabled = true;
    } else {
      this.rowsInput.value = null;
      this.colsInput.checked = false;
      this.buttonElement.setAttribute("aria-pressed", "false");
      this.removeButton.setAttribute("disabled", "");
      this.submitButton.disabled = false;
    }

    this.buttonElement.disabled = false; //!isEnabled;
  }

  destroy() {
    this.buttonElement.removeEventListener("click", this.buttonAction);
    this.removeButton.removeEventListener("click", this.removeAction);
    this.submitButton.removeEventListener("submit", this.submitAction);
    this.containerElement.remove();
    this.containerElement = null;
    this.buttonElement = null;
    this.rowsInput = null;
    this.colsInput = null;
    this.submitButton = null;
    this.removeButton = null;
    this.dialogElement = null;
    this.buttonAction = null;
    this.submitAction = null;
    this.removeAction = null;
  }

  removeButtonClickCallback() {
    return () => {
      if(!deleteTable(this.view.state, null)) {
        return false;
      }

      this.rowsInput.value = null;
      this.colsInput.value = null;
      deleteTable(this.view.state, this.view.dispatch);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }

  buttonClickCallback() {
    return () => {
      setActiveTool(this.buttonElement)(this.view.state, this.view.dispatch);
    }
  }

  submitButtonClickCallback() {
    return (event) => {
      event.preventDefault();
      const rowCount = parseInt(this.rowsInput.value, 10),
        colCount = parseInt(this.colsInput.value, 10),
        isActive = getNode(this.view.state, customSchema.nodes.table);

      if(!insertTable(rowCount, colCount)(this.view.state, null)) {
        return false;
      }

      insertTable(rowCount, colCount)(this.view.state, this.view.dispatch);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }
}
